import React from 'react';
import { Box, Typography } from '@mui/material';
import useTranslate from '../../../../customHooks/useTranslate';
import { useProcesses } from '../../../../contexts/ProcessesContext';
import ProcessItem from './ProcessItem';
import ActivityEmptyState from '../ActivityEmptyState';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';

/**
 * Displays the shared processes in the activity popover.
 * @returns The processes heading and list or empty state.
 */
const Processes = () => {
    const translate = useTranslate();
    const { processes, isLoading, isWaitingForProcess, totalActiveProcesses } =
        useProcesses();

    return (
        <Box
            component='section'
            aria-label={translate('active_processes')}
            aria-busy={isLoading || isWaitingForProcess}
        >
            <Box className='activity__section-title'>
                <Typography component='h2' variant='subtitle1'>
                    {translate('active_processes')}
                </Typography>
            </Box>
            {processes.length > 0 ? (
                <Box component='ul' className='activity__process-list'>
                    {processes.map(process => (
                        <Box component='li' key={process.id}>
                            <ProcessItem process={process} />
                        </Box>
                    ))}
                </Box>
            ) : !isLoading && !isWaitingForProcess ? (
                <ActivityEmptyState section='processes' />
            ) : null}
            {isLoading && processes.length === 0 && (
                <div className='activity__empty' aria-hidden='true'>
                    <LoadingPlaceholder variant='text' height={24} />
                    <LoadingPlaceholder variant='text' height={24} />
                </div>
            )}
            {isWaitingForProcess && (
                <Typography
                    role='status'
                    variant='body2'
                    className='activity__empty'
                >
                    {translate('activity_preparing_process')}
                </Typography>
            )}
            {totalActiveProcesses > processes.length && (
                <Typography
                    variant='caption'
                    className='activity__process-total'
                >
                    {translate('active_processes')}: {processes.length} /{' '}
                    {totalActiveProcesses}
                </Typography>
            )}
        </Box>
    );
};

export default Processes;
